import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Redirect = () => import("@/views/pages/Redirect");
const Cadastro = () => import("@/views/pages/Cadastro");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");
const RegisterFederacao = () => import("@/views/pages/RegisterFederacao");
const RegisterArbitro = () => import("@/views/pages/RegisterArbitro");
const RegisterGerente = () => import("@/views/pages/RegisterGerente");

//pacientes
const Pacientes = () => import(/* webpackChunkName: "pacientes" */ "@/views/pacientes/Pacientes");

// Profissionais
const Profissionais = () => import("@/views/profissionais/Profissionais");

// Calendario
const Calendario = () => import("@/views/calendario/Calendario");

// Convenios
const Convenios = () => import("@/views/convenios/Convenios");

// Salas
const Salas = () => import("@/views/salas/Salas");

//Consultas

const Consultas = () => import("@/views/consultas/Consultas");

//Cadastro
const CadastroUser = () => import("@/views/cadastro/Cadastro");

//Controle PPM
const controlePPM = () => import("@/views/controlePPM/controlePPM");

const integrationPatient = () =>
  import("@/views/integration/integrationPatients");
const integrationConsults = () =>
  import("@/views/integration/integrationConsults");

import { default as jwtVerify } from "../jwt-data-validation";

Vue.use(Router);

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/redirect",
      name: "Redirect",
      component: Redirect,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "pacientes",
          name: "Pacientes",
          component: Pacientes,
        },
        {
          path: "profissionais",
          name: "Profissionais",
          component: Profissionais,
        },

        {
          path: "calendario/listar",
          name: "Calendario",
          component: Calendario,
        },
        {
          path: "consultas",
          name: "Consultas",
          component: Consultas,
        },

        {
          path: "convenios",
          name: "Convenios",
          component: Convenios,
        },

        {
          path: "salas",
          name: "Salas",
          component: Salas,
        },

        {
          path: "cadastro",
          name: "Cadastro",
          component: CadastroUser,
        },
        {
          path: "integration/patients",
          name: "integration",
          component: integrationPatient,
        },
        {
          path: "integration/consults",
          name: "integration",
          component: integrationConsults,
        },
        {
          path: "controle-ppm",
          name: "Controle de PPM",
          component: controlePPM,
        },
        {
          path: "theme",
          redirect: "/theme/colors",
          name: "Theme",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
          ],
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },

        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/coreui-icons",
          name: "CoreUI Icons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "coreui-icons",
              name: "Icons library",
              component: CoreUIIcons,
            },
            {
              path: "brands",
              name: "Brands",
              component: Brands,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
      ],
    },
    {
      //
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
        {
          path: "register-federacao",
          name: "RegisterFederacao",
          component: RegisterFederacao,
        },
        {
          path: "register-arbitro",
          name: "RegisterArbitro",
          component: RegisterArbitro,
        },
        {
          path: "register-gerente",
          name: "RegisterGerente",
          component: RegisterGerente,
        },
      ],
    },
  ],
});

// Handle dynamic chunk loading errors (e.g., after dev-server restart or network hiccup)
router.onError((error) => {
  const chunkFailed = /Loading chunk (\d+|[a-z0-9_-]+) failed/i.test(error.message);
  if (chunkFailed) {
    const hasRetried = sessionStorage.getItem("_chunk_retry");
    if (!hasRetried) {
      sessionStorage.setItem("_chunk_retry", "1");
      // Force full reload to fetch fresh index & chunk map
      window.location.reload();
    } else {
      // Already retried once, clear flag to avoid loops
      sessionStorage.removeItem("_chunk_retry");
    }
  }
});

router.beforeEach((to, from, next) => {
  if (!jwtVerify.parseJwt() && to.name !== "Login") {
    jwtVerify.clearUserStorage();
    next({
      path: "login",
      replace: true,
    });
  } else {
    next();
  }
});

export default router;
